import { errorTemplateParser } from './errorTemplateParser';
import { tradePlanUpdateParser } from './tradePlanUpdateParser';
import { warningParser } from './warningParser';

const notificationDetailsParsers = {
  TRADE_PLAN_UPDATE: tradePlanUpdateParser,
  WARNING: warningParser,
  ERROR: errorTemplateParser,
};


export function getNotificationDetailsParser(notificationDetails) {
  if (notificationDetails) {
    if (notificationDetails.notificationType) {
      const parser = notificationDetailsParsers[notificationDetails.notificationType] ?? null;

      if (parser) {
        return parser(notificationDetails);
      }
    }
  }
  return null;
}
